module.exports = __webpack_public_path__ + "static/img/merchant_feature_1.11abbf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_1.png
// module id = MGef
// module chunks = 8